export default "__VITE_PUBLIC_ASSET__1d18f2b7__"